export default __webpack_public_path__ + "static/media/slider-img-3.6d4d78a0.png";